<template>
  <div>
    <el-dialog width="750px" class="dialog-mini body-small" :title="'列显示设置'" :visible.sync="visible" @close="handleCancel">
        <el-form ref="setForm" size="small" label-position="left">
           <el-row>
            <el-col :span="20">
              <el-transfer
                v-model="outputListTemp"
                :data="inputList"
                :titles="titles"
                target-order="push"
                @right-check-change="rightCheck"
              ></el-transfer>
            </el-col>
            <el-col :span="4" style="margin-top: 95px;">
              <div style="margin-bottom: 10px;">
                <el-button icon="el-icon-arrow-up" circle :disabled="upDownDisable" @click="upData"></el-button>
              </div>
              <div>
                <el-button icon="el-icon-arrow-down" circle :disabled="upDownDisable" @click="downData"></el-button>
              </div>
            </el-col>
          </el-row>
        </el-form>
        <div slot="footer">
          <el-button size="mini" @click="handleCancel">取消</el-button>
          <el-button size="mini" type="primary" @click="setField">确认</el-button>
        </div>
    </el-dialog>
  </div>
</template>
<script>
import * as sysfields from '@/api/sysfields';
export default {
  name: 'myTransfer',
  props: ['value', 'titles', 'code', 'dialogVisible'],
  data() {
    return {
      upDownDisable: true,
      tempSelectionKeys: [],
      outputListTemp: [],
      inputList: [],
      visible: false
    };
  },
  watch: {
    // value(val) {
    //   this.outputListTemp = val
    // },
    // outputListTemp(val) {
    //   this.$emit('input', val)
    // },
    dialogVisible(val) {
      this.visible = val;
      if (val) {
        sysfields.loadSetRight(this.code).then(response => {
          this.outputListTemp = response.result;
        });
      }
    }
  },
  mounted() {},
  created() {
    sysfields.loadSetLeft(this.code).then(response => {
      this.inputList = response.result.map(function(item, index, input) {
        return { key: item.id, label: item.title };
      });
    });
  },
  methods: {
    handleCancel() {
      this.visible = false;
      this.$emit('update:dialogVisible', false);
    },
    rightCheck(selectionKeys, changeKeys) {
      this.tempSelectionKeys = selectionKeys;
      if (selectionKeys.length > 0) {
        this.upDownDisable = false;
      } else {
        this.upDownDisable = true;
      }
    },
    upData() {
      if (this.tempSelectionKeys.length > 1) {
        this.$message({
          type: 'warning',
          message: '仅支持单选调顺序'
        });
        return;
      }
      let indexNum = 0;
      for (let i = 0; i < this.tempSelectionKeys.length; i++) {
        indexNum = this.outputListTemp.indexOf(this.tempSelectionKeys[i]);
        if (indexNum > 0) {
          this.outputListTemp.splice(
            indexNum - 1,
            0,
            this.tempSelectionKeys[i]
          );
          this.outputListTemp.splice(indexNum + 1, 1);
        }
      }
    },
    downData() {
      if (this.tempSelectionKeys.length > 1) {
        this.$message({
          type: 'warning',
          message: '仅支持单选调顺序'
        });
        return;
      }
      let indexNum = 0;
      for (let i = 0; i < this.tempSelectionKeys.length; i++) {
        indexNum = this.outputListTemp.indexOf(this.tempSelectionKeys[i]);
        if (indexNum > -1 && indexNum !== this.outputListTemp.length - 1) {
          this.outputListTemp.splice(
            indexNum + 2,
            0,
            this.tempSelectionKeys[i]
          );
          this.outputListTemp.splice(indexNum, 1);
        }
      }
    },
    setField() {
      const tempData = {};
      tempData.fIds = this.outputListTemp;
      tempData.moduleCode = this.code;
      sysfields.addUserField(tempData).then(() => {
        this.handleCancel();
        this.$emit('filter');
        this.$notify({
          title: '成功',
          message: '设置成功',
          type: 'success',
          duration: 2000
        });
      });
    }
  }
};
</script>
